import { api, unwrap } from './http';

export default {
  deleteEvent: async (eventId) => {
    const data = await unwrap(api.delete(`/TrainingEvents/${eventId}`));
    if (data) return data;
    throw new Error('Server returned false');
  },

  deleteClassSeries: async (classId, classSeriesId) => {
    const data = await unwrap(api.delete(`/Classes/${classId}/Series/${classSeriesId}`));
    if (data) return data;
    throw new Error('Server returned false');
  },
};
